import { useEffect, useState } from "react";
import { api } from "../api/http.js";
import { useLocaleStore } from "../i18n/index.js";
import type { Version } from "./types.js";
import { stamp, useAdminText } from "./text.js";
import "./admin.css";

export function VersionDetails({ version }: { version: Version }) {
  const t = useAdminText();
  const locale = useLocaleStore((s) => s.locale);
  return <div className="gm-version">
    <p><strong>ZEnd {version.gameVersion}</strong> · API {version.apiVersion} · Content {version.contentVersion}</p>
    <p>{t("development")}</p>
    {version.identity ? <details><summary>{t("observed")} · {stamp(version.identity.capturedAt)}</summary>
      <p>{version.identity.dirty ? t("dirty") : t("clean")}</p><code>{version.identity.head}</code><code>SHA256 {version.identity.inputSha256}</code>
    </details> : <p>{t("observed")}: {t("unavailable")}</p>}
    {version.changelog.map((entry) => <details key={`${entry.date}-${entry.title.en}`}><summary>{entry.date} · {entry.title[locale]}</summary><ul>{entry.changes.map((change) => <li key={change.en}>{change[locale]}</li>)}</ul></details>)}
  </div>;
}

/** Public, account-free metadata: safe to mount in Settings for every player. */
export function VersionPanel() {
  const t = useAdminText();
  const [version, setVersion] = useState<Version | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => { let current = true; void api<Version>("GET", "/api/version").then((v) => { if (current) setVersion(v); }).catch((e: unknown) => { if (current) setError(String(e)); }); return () => { current = false; }; }, []);
  return <section className="gm-version-panel"><h2>{t("version")}</h2>{version ? <VersionDetails version={version} /> : <p role={error ? "alert" : "status"}>{error ?? t("loading")}</p>}</section>;
}
